module.exports = __webpack_public_path__ + "img/arh_14.130c36ab.jpg";